// extracted by mini-css-extract-plugin
export default {"form":"styles_form__94-dz","button":"styles_button__5iYjJ","center":"styles_center__m4Qfs","texts":"styles_texts__U2cbq","text":"styles_text__dzGu0"};